export const fuelHelper = type => {
  switch (type) {
    case 'gas_92':
      return '92 無鉛汽油';
    case 'gas_95':
      return '95 無鉛汽油';
    case 'gas_98':
      return '98 無鉛汽油';
    default:
      return '超級柴油';
  }
};
